import './../main'
import Component from './Component';
import 'select2'

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Dropdown extends Component {

    decorator () {
        return {
            selector : '.js-dropdown',
            name : 'Dropdown',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        if (Modernizr.touchevents) { return; }

        this.render();
    }

    // render select2
    render () {
        const _theme = this.$element.data('dropdown-theme');

        const Select2 = this.$element.select2({
            theme: _theme || 'default',
            width: 'resolve',
            dropdownParent: this.$element.parent(),
            templateResult: (data, container) => {
                if (data.element) {
                    let dropClass = data.element.getAttribute('class');

                    if (dropClass != '' && dropClass != null) {
                        dropClass = dropClass.split(' ');
                        for (let i = 0; i < dropClass.length; i++) {
                            container.classList.add(dropClass[i]);
                        }
                    }
                }

                return data.text;
            }
        });


        Select2.on('select2:open', e => {
            let _obj = {
                parent: e.target.parentElement.querySelector('.select2-dropdown'),
                results: e.target.parentElement.querySelector('.select2-results'),
                options: e.target.parentElement.querySelector('.select2-results__options')
            }

            e.target.parentElement.classList.add('is-active');

            if (e.target.length < 9) { return; }

            this.addScrollbar(_obj);
        });


        Select2.on('select2:close', e => {
            e.target.parentElement.classList.remove('is-active');
        });

        return Select2;
    }


    addScrollbar (_obj) {

        const upArrow = `
            <a href="javascript:;" class="select2-dropdown-scroll up">
                <span class="o-icon">
                    <svg><use xlink:href="#caret-up"></use></svg>
                </span>
            </a>
        `;

        const downArrow = `
            <a href="javascript:;" class="select2-dropdown-scroll down">
                <span class="o-icon">
                    <svg><use xlink:href="#caret-down"></use></svg>
                </span>
            </a>
        `;

        _obj.parent.classList.add('has-scrolling');

        _obj.parent.insertAdjacentHTML('afterbegin', upArrow);
        _obj.parent.insertAdjacentHTML('beforeend', downArrow);

    }


    removeScrollbar (_obj) {
        _obj.parent.classList.remove('has-scrolling');
        _obj.parent.querySelector('.select2-dropdown-scroll').remove();
    }

}
